// utils/openPdf.ts
export async function openPdfFromBlobResponse(res: any, fallbackName = "ticket.pdf") {
  // 1) If backend sent JSON error instead of a PDF, detect & throw
  const contentType =
    res?.headers?.["content-type"] || (res?.data?.type as string) || "";
  if (!contentType.includes("pdf")) {
    try {
      // res.data is a Blob when responseType:'blob'
      const text = await (res?.data?.text?.() ?? new Response(res.data).text());
      throw new Error(text || "Server did not return a PDF.");
    } catch {
      throw new Error("Server did not return a PDF.");
    }
  }

  const blob = res.data as Blob;
  const url = URL.createObjectURL(blob);

  // 2) Create a tab synchronously to avoid popup blockers
  const win = window.open("", "_blank", "noopener,noreferrer");
  if (win) {
    win.location.href = url;
  } else {
    // Fallback: programmatic click to new tab
    const a = document.createElement("a");
    a.href = url;
    a.target = "_blank";
    a.rel = "noopener";
    a.download = fallbackName; // if the browser decides to download
    document.body.appendChild(a);
    a.click();
    a.remove();
  }

  // 3) Revoke later (don’t revoke immediately!)
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
